import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-icon-verified',
  templateUrl: './icon-verified.component.svg',
})
export class IconVerifiedComponent {
  public readonly width: InputSignal<number> = input.required<number>();
  public readonly height: InputSignal<number> = input.required<number>();
}
